import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import SearchBarSection from './SearchBarSection';
import { getSectionPropsByType} from './searchBarHelpers';

import styles from './SearchBar-style.scss';

const SearchBarOverlay = ({ visible, suggestions, handleRowClick }) => {
    const overlayClasses = classnames({
        [styles.overlay]: true,
        [styles.isVisible]: visible
    });

    if (!suggestions) {
        return null;
    }

    return (
        <div className={overlayClasses}>
            {suggestions.map(section => {
                const { title, urlSection } = getSectionPropsByType(section.type);
                const { terms } = section;
                return terms && terms.length ?
                    <SearchBarSection
                        key={title}
                        title={title}
                        urlSection={urlSection}
                        terms={terms}
                        handleRowClick={handleRowClick}
                    /> : null;
            })}
        </div>
    );
};

SearchBarOverlay.propTypes = {
    visible: PropTypes.bool,
    suggestions: PropTypes.array,
    handleRowClick: PropTypes.func
};

export default SearchBarOverlay;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBarOverlay.jsx